import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  effect,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomerModel } from 'src/models/mongo/customer.model';
import { UserModel } from 'src/models/mongo/user.model';
import { LocalStorageService } from 'src/servcies/localstorage-service';
import { Endpoint, Group, Unicode } from 'src/shared/Endpoint';
import { Utilities } from 'src/shared/utilities';
import { CustomerInfoPopupComponent } from '../customer-info-popup/customer-info-popup.component';
import { RejectionPopupComponent } from '../rejection-popup/rejection-popup.component';
import { POCModel } from 'src/models/mongo/poc.model';
import { DomainModel } from '../../models/mongo/domain.model';
import { OpportunityService } from 'projects/opportunity/src/public-api';

@Component({
  selector: 'poc-google-doc-card',
  templateUrl: './poc-google-doc-card.component.html',
  styleUrls: ['./poc-google-doc-card.component.scss'],
})
export class POCGoogleDocCardComponent implements OnInit, AfterViewInit {
  currentUser: UserModel;
  domainSelected;
  @Input() cardData: any = {
    module: '',
    customer_domain: null,
    customer_org: null,
    googleDocUrl: '',
    createdUser: {},
    approval_phases: [],
  };
  @Input() poc: POCModel = new POCModel();
  @Input() opporunityID: string;
  searchResultCustomers = [];
  @Output() selectCustomerEmitter = new EventEmitter<CustomerModel>();
  @Output() selectDomainEmitter = new EventEmitter<DomainModel>();
  add: boolean = false;
  approve: boolean = false;
  send: boolean = false;
  withoutAction: boolean = false;
  showSendToApprove: boolean = true;
  loginUsersData: any;
  isGWS: boolean;
  @Output() createEmitter = new EventEmitter<any>();
  @Output() approveEmitter = new EventEmitter<any>();
  @Output() editEmitter = new EventEmitter<any>();
  @Output() draftEmitter = new EventEmitter<any>();
  @Output() custEmitter = new EventEmitter<any>();
  @ViewChild('rejectPOCPopupModal')
  rejectPOCPopupModal: RejectionPopupComponent;
  canSendToCustomer: boolean = false;
  @ViewChild('poccustomerInfoPopup')
  poccustomerInfoPopup: CustomerInfoPopupComponent;
  customerInfoAdded: any;
  saveText: string = 'Save & Send for Approval';

  constructor(
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private oppService: OpportunityService
  ) {
    this.currentUser = this.localStorage.getLoggedinUserModel();
    this.loginUsersData = Utilities.getLoginUserInfo(localStorage);
    if (this.currentUser.isAdmin) this.saveText = 'Save';

    effect(() => {
      this.customerInfoAdded =
        this.oppService.opportunity().customer_info_added;
    });
  }

  ngAfterViewInit(): void {
    if (this.poc?._id) {
      this.add = false;
      this.showSendToApprove =
        this.poc.draft && this.currentUser._id == this.poc.created_by_rfid;
      if (!this.poc.draft) {
        if (!this.poc.managerApprovalPart) this.setPOCPhasesData();
        this.approve = this.poc.canApprove(this.currentUser);
        this.canSendToCustomer = this.poc.canSendToCustomer(this.currentUser);
      }
      this.cardData = {
        module: 'poc',
        customer_domain: this.cardData.customer_domain,
        customer_org: this.cardData.customer_org,
        googleDocUrl: this.poc.googleDocUrl,
        domain_rfid: this.cardData.domain_rfid,
        createdUser: {
          name: this.poc.user_poc.created_user_name,
          role: this.poc.user_poc.created_user_role,
          date: this.poc.created_at,
          text: 'Created poc',
          img: this.poc.user_poc.created_user_img,
        },
        approval_phases: this.poc?.approval_phases,
      };
      this.setPOCPhasesData();
    } else if (this.poc) {
      this.add = true;
      this.cardData = {
        module: 'poc',
        customer_domain: this.cardData.customer_domain,
        customer_org: this.cardData.customer_org,
        googleDocUrl: this.poc.googleDocUrl,
        domain_rfid: this.cardData.domain_rfid,
        start_date: this.cardData.startDate,
      };
    }
    this.cardData.googleDocUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://docs.google.com/document/d/' +
        this.poc.google_doc_id +
        '/edit?usp=sharing&embed=true'
    );
  }

  ngOnInit(): void {}

  async onSearchCustomerEnter(e) {
    var value = e.term ?? e.target.value;
    if (value && value.length > 2) {
      if (!Utilities.isNullOrEmpty(value)) this.searchResultCustomers = [];
      var params = new HttpParams()
        .set(Unicode.CUSTOMER_FILTER, value)
        .set(Unicode.VIEW_ALL, this.currentUser.canViewAll);
      await this.http
        .get(Endpoint.API_URL + '' + Endpoint.SEARCH_FOR_CUSTOMERS_LIST, {
          params: params,
        })
        .toPromise()
        .then((resp: any) => {
          if (resp && resp.domains && resp.domains.length > 0) {
            this.searchResultCustomers = resp.domains ?? [];
          }
        });
    }
  }

  async selectCustomer() {
    if (this.domainSelected) {
      var domain = this.domainSelected;
      this.cardData.customer_domain = domain.domain;
      this.cardData.customer_org = domain.organisation_name;
      this.cardData.domain_rfid = domain._id;
      this.selectDomainEmitter.emit(domain);

      var new_doc_name =
        this.datePipe.transform(new Date(), 'YYYY-MM-dd') +
        ' POC - ' +
        domain.organisation_name;

      var params = new HttpParams()
        .set(Unicode.CUSTOMER_NAME, domain.organisation_name)
        .set(Unicode.FILE_ID, this.poc.google_doc_id)
        .set(Unicode.NEW_FILE_NAME, new_doc_name);
      await this.http
        .get(Endpoint.API_URL + '' + Endpoint.RENAME_DOCUMENT, {
          params: params,
        })
        .toPromise()
        .then((resp: any) => {
          if (resp && resp.success == true) {
            console.log('updated successfully');
          }
        });
    }
  }

  createPOC(draft: boolean = false) {
    if (Utilities.isNullOrEmpty(this.cardData.domain_rfid)) {
      alert('No Customer Selected');
      return;
    }
    var receivers = [];
    var params = new HttpParams();
    if (!draft) {
      if (!Utilities.isNullOrEmpty(this.currentUser.manager_id)) {
        receivers.push(this.currentUser.manager_email);
        params = params.set(Unicode.EMAIL_RECEIVERS, JSON.stringify(receivers));
      }
    }
    var poc = new POCModel();
    poc.created_by_rfid = this.currentUser._id;
    poc.domain_rfid = this.cardData.domain_rfid;
    poc.opportunity_rfid = this.opporunityID;
    poc.is_gcp = !this.isGWS;
    poc.draft = draft;
    poc.google_doc_id = this.poc.google_doc_id;
    poc.approval_phases = [];
    poc.start_date = this.cardData.start_date;
    var oppDependencyOn = null;
    if (!Utilities.isNullOrEmpty(this.currentUser.manager_id)) {
      poc.approval_phases = [
        {
          role: Group.Engineer_Manager,
          name: this.currentUser.manager_name,
          email: this.currentUser.manager_email,
          id: this.currentUser.manager_id,
          img: this.currentUser.imageUrl,
        },
      ];
      oppDependencyOn = Group.ENGINEER;
    } else {
      poc.approval_phases = [{ role: Group.CUSTOMER }];
      oppDependencyOn = Group.ENGINEER;
    }
    if (!Utilities.isNullOrEmpty(this.opporunityID))
      params = params.set(Unicode.DEPENDENCY_ON, oppDependencyOn);
    this.http
      .post(Endpoint.API_URL + Endpoint.ADD_POC, poc, { params: params })
      .toPromise()
      .then((resp: any) => {
        if (resp?.poc_rfid) {
          this.poc = poc;
          this.poc._id = resp.poc_rfid;
          this.poc.draft = draft;
          this.poc.consumed_time = resp.consumed_time;
          this.poc.user_poc = {
            created_user_name: this.currentUser.user_name,
          };
          this.poc.created_at = new Date();
          this.poc.created_date_string = Utilities.toStringDateFormat(
            this.datePipe,
            new Date(),
            'dd MMM,yyyy-hh:mma'
          );
          this.add = false;
          //
          this.setPOCPhasesData();
          this.createEmitter.emit(this.poc);
        } else {
          alert(resp.message);
        }
      });
  }

  approvePoc(reason: string = null) {
    var oppDependencyOn = null;
    var mainGrpName =
      this.currentUser.groups.find((x) => x.main == true)?.name ?? '';
    var approvalPhases = this.poc.approval_phases ?? [];
    var role = approvalPhases.find(
      (x) =>
        x.role && x.role.toLowerCase().indexOf(mainGrpName.toLowerCase()) >= 0
    );
    if (role && Utilities.isNullOrEmpty(role.date)) {
      role.name = this.currentUser.user_name;
      role.email = this.currentUser.email;
      role.img = this.currentUser.imageUrl;
      role.id = this.currentUser._id;
      role.date = new Date();
      role.approved = Utilities.isNullOrEmpty(reason);
      if (!Utilities.isNullOrEmpty(reason)) role.rejection_reason = reason;
    } else {
      var row: any = {
        role: Group.Engineer_Manager,
        name: this.currentUser.getFullName(),
        email: this.currentUser.email,
        img: this.currentUser.imageUrl,
        id: this.currentUser._id,
        date: new Date(),
        approved: Utilities.isNullOrEmpty(reason),
      };
      if (!Utilities.isNullOrEmpty(reason)) row.rejection_reason = reason;
      approvalPhases.push(row);
    }
    if (Utilities.isNullOrEmpty(reason)) {
      oppDependencyOn = 'PreSales';
      approvalPhases.push({ role: Group.CUSTOMER });
    }
    this.poc.approval_phases = approvalPhases;
    var receivers = [this.poc.user_poc?.created_user_email];
    receivers.push(
      ...this.poc?.approval_phases
        ?.filter(
          (x) =>
            x.email &&
            x.email.toLowerCase() !== this.currentUser.email.toLowerCase()
        )
        .map((x) => x.email)
    );
    this.poc.approval_phases.forEach((phase) => {
      if (phase?.date && phase.date.$date?.$numberLong)
        phase.date = new Date(Number.parseInt(phase.date.$date?.$numberLong));
    });
    var body = {
      receivers: JSON.stringify(receivers),
      approval_phases: this.poc.approval_phases,
      poc_action: !Utilities.isNullOrEmpty(reason) ? 'reject' : 'approve',
      opportunity_rfid: this.poc.opportunity_rfid,
    };
    var params = new HttpParams();
    if (!Utilities.isNullOrEmpty(this.poc.opportunity_rfid))
      params = params.set(Unicode.DEPENDENCY_ON, oppDependencyOn);
    this.http
      .put(Endpoint.API_URL + Endpoint.UPDATE_POC + this.poc._id, body, {
        params: params,
      })
      .toPromise()
      .then((resp: any) => {
        if (resp?.approval_phases) {
          this.poc.approval_phases = resp.approval_phases;
          //
          this.setPOCPhasesData();
          this.approveEmitter.emit(this.poc);
        } else {
          alert(resp.message);
        }
      });
  }

  rejectPOCPopup() {
    this.rejectPOCPopupModal.show();
  }

  rejectPOC(reason) {
    if (!Utilities.isNullOrEmpty(reason)) {
      this.rejectPOCPopupModal.hide();
      this.approvePoc(reason);
    } else alert('Add Rejection Reason please');
  }

  sendpocToCustPopup() {
    this.poccustomerInfoPopup.show();
  }

  sendPOCToCustomer(customerInfo) {
    this.custEmitter.emit(customerInfo);
    this.poccustomerInfoPopup.hide();
  }

  sendDraftPocForApproval() {
    var receivers = [];
    if (!Utilities.isNullOrEmpty(this.currentUser.manager_id))
      receivers.push(this.currentUser.manager_email);
    var body = {
      receivers: JSON.stringify(receivers),
      poc_rfid: this.poc._id,
    };
    this.http
      .put(Endpoint.API_URL + Endpoint.SEND_POC_FOR_APPROVAL, body)
      .toPromise()
      .then((resp: any) => {
        if (resp?.poc_rfid) {
          this.poc.draft = false;
          //
          this.setPOCPhasesData();
          this.draftEmitter.emit(this.poc);
        } else {
          alert(resp.message);
        }
      });
  }

  setPOCPhasesData() {
    if (this.poc.approval_phases) {
      this.poc.managerApprovalPart = this.poc
        .getSortedApprovalPhasesByDateDesc()
        .find(
          (x) =>
            x.role &&
            x.role.toLowerCase() == Group.Engineer_Manager.toLowerCase()
        );
      this.poc.sendingToCustomerPart = this.poc
        .getSortedApprovalPhasesByDateDesc()
        .find(
          (x) => x.role && x.role.toLowerCase() == Group.CUSTOMER.toLowerCase()
        );
    }
    if (this.poc.sendingToCustomerPart && !this.poc.sendingToCustomerPart.date)
      this.poc.sendingToCustomerPart.current = true;
    if (this.poc.managerApprovalPart && !this.poc.managerApprovalPart.date)
      this.poc.managerApprovalPart.current = true;

    this.cardData.managerApprovalPart = this.poc.managerApprovalPart;
    this.cardData.sendingToCustomerPart = this.poc.sendingToCustomerPart;
  }
}
